import $ from 'jquery';

export function getFormData($form) {
  const result = {};

  const fieldSelectors = [
    'input:not([type=radio], [type=checkbox])',
    'input[type=checkbox]:checked',
    'input[type=radio]:checked',
    'input[type=checkbox]:selected',
    'select, textarea, button',
  ];

  // get all fields
  const $fields = fieldSelectors.reduce(
    ($elems, fieldSelector) => $elems.add($form.find(fieldSelector)),
    $(),
  );

  $fields.each((i, field) => {
    const key = field.name || '';

    if (key.length > 0) {
      // if duplicate keys, convert to or push to an array
      if (result[key] && result[key] !== field.value) {
        // if this key is already an array
        if (result[key] instanceof Array) {
          result[key].push(field.value);
        } else {
          // start an array of values
          result[key] = [result[key], field.value];
        }
      } else {
        // just store the value like normal
        result[key] = field.value;
      }
    }
  });

  return result;
}
